import React from "react";
import ActionModal from "../../molecules/modal/ActionModal";

interface DeleteModalProps {
  title: string;
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  subTitle?: string;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  title,
  show,
  onClose,
  onConfirm,
  subTitle,
}) => {
  return (
    <ActionModal
      title={title}
      show={show}
      onClose={onClose}
      onConfirm={onConfirm}
    >
      <p className="modal-content">{subTitle}</p>
    </ActionModal>
  );
};

export default DeleteModal;
